import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  POST_AUTH_HISTORY_REQUEST: '',
  POST_AUTH_HISTORY_SUCCESS: '',
  POST_AUTH_HISTORY_FAILURE: '',

  GET_SPEC_CODE_LIST_REQUEST: '',
  GET_SPEC_CODE_LIST_SUCCESS: '',
  GET_SPEC_CODE_LIST_FAILURE: '',
};

types = setStoreTypeValues(types, 'authHistory');

export default types;
